var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffersEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 72,
    viewBox: "0 0 66 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 0.166626C1.64543 0.166626 0.75 1.06206 0.75 2.16662V69.8333C0.75 70.9379 1.64543 71.8333 2.75 71.8333H63.25C64.3546 71.8333 65.25 70.9379 65.25 69.8333V2.16663C65.25 1.06206 64.3546 0.166626 63.25 0.166626H2.75ZM33.0009 18.0833C34.6812 18.0833 36.0433 19.4465 36.0433 21.1282V32.9555H47.8771C49.5574 32.9555 50.9195 34.3188 50.9195 36.0004C50.9195 37.682 49.5574 39.0452 47.8771 39.0452H36.0433V50.8718C36.0433 52.5534 34.6812 53.9166 33.0009 53.9166C31.3206 53.9166 29.9584 52.5534 29.9584 50.8718V39.0452H18.1286C16.4483 39.0452 15.0862 37.682 15.0862 36.0004C15.0862 34.3188 16.4483 32.9555 18.1286 32.9555H29.9584V21.1282C29.9584 19.4465 31.3206 18.0833 33.0009 18.0833Z",
    fill: "#949394"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersEmpty);
export default __webpack_public_path__ + "static/media/offers-empty.91e5545e75d9afa429788dab79567bb2.svg";
export { ForwardRef as ReactComponent };